// extracted by mini-css-extract-plugin
export default {"grid":"w_pK5UhmTdsOrySEbpsY","flex":"UVJhTp__W_YVGrqoKyT2","section":"l1net3M1ywTgBGnazuFn","subtitle":"XxVeN0QYzrEygfmcCrUx"};